import { render, staticRenderFns } from "./mortgage-check.vue?vue&type=template&id=4894df9c&scoped=true"
import script from "./mortgage-check.vue?vue&type=script&lang=ts"
export * from "./mortgage-check.vue?vue&type=script&lang=ts"
import style0 from "./mortgage-check.vue?vue&type=style&index=0&id=4894df9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4894df9c",
  null
  
)

export default component.exports